window.coma = window.coma || {};

window.coma.lightbox = (function ($, undefined) {

    // PRIVATE FUNCTIONS
    var _private = {
        init: function() {

            // add lightbox events
            this.addLightboxEvents();
        },

        addLightboxEvents: function() {
            function handleClick(e) {
                if ($(this).closest('footer').length > 0) {
                    return;
                }
                e.preventDefault();

                // mandatory data
                var data = {};
                var tmp = (typeof $(this).data('target') != 'undefined') ? $(this).data('target') : $(this).attr('href');
                if (typeof tmp == 'undefined') return false; // exit lightbox if there is no target to show
                else data.target = tmp;

                // optional data
                tmp = (typeof $(this).attr('title') != 'undefined') ? $(this).attr('title') : $(this).next().text();
                if (typeof tmp != 'undefined') data.title = tmp;
                else data.title = false;
                
                tmp = $(this).attr('alt');
                if (typeof tmp != 'undefined') data.alt = tmp;
                else data.alt = false;

                tmp = $(this).data('copyright');
                if (typeof tmp != 'undefined') data.copyright = tmp;
                else data.copyright = false;

                tmp = $(this).data('download');
                if (typeof tmp != 'undefined') data.download = tmp;
                else data.download = false;

                var id = $(this).attr('id');
                if (typeof id != 'undefined' && id) {
                    window.location.hash = id;
                }

                // elements
                var $lightbox = $('<div id="lightbox"></div>');
                var $wrapper = $('<div id="lightbox-wrapper"></div>');

                // append close button
                var $close = $('<a href="#" title="schließen" class="lightbox-close"></a>');
                $wrapper.append($close);

                // main content (target)

                // check for a youtube url
                tmp = _private.getYoutubeEmbedUrl(data.target);

                if (false != tmp) {
                    $wrapper.append($('<iframe class="youtube" src="' + tmp + '" frameborder="0" allowfullscreen></iframe>'));
                    // width="853" height="480"
                } else {
                    $wrapper.append($('<img src="' + data.target + '" alt="' + data.alt + '" />'));
                }

                // sub content (at least one of title, copyright or download)
                if (data.title !== false || data.copyright !== false || data.download !== false) {
                    var $subcontent = $('<div class="lightbox-caption"></div>');

                    if (data.copyright !== false) {
                        $subcontent.append('<span class="copyright">' + data.copyright + '</span>');
                    }

                    if (data.title !== false) {
                        $subcontent.append('<span class="title">' + data.title + '</span>');
                    }

                    if (data.download !== false) {
                        $subcontent.append('<a href="' + data.download + '" target="_blank" class="download">Download</a>');
                        $subcontent.find('a.download').on('click', function(e) {
                            e.stopPropagation();
                        });
                    }

                    $wrapper.append($subcontent);
                }

                // combine wrapper with lightbox
                $lightbox.append($wrapper);


                // fade out on background click
                $lightbox.on('click', function() {
                    $(this).fadeOut(400, function(){ $(this).remove(); });
                    window.location.hash = '';
                });
                $close.on('click', function() {
                    $lightbox.fadeOut(400, function(){ $(this).remove(); });
                    window.location.hash = '';
                });
                // but do not fade out on content click
                $wrapper.on('click', function() { return false; } );

                // show lightbox
                $lightbox.appendTo('body').fadeIn(400, function() {
                    var margin_top = Math.floor(($lightbox.height() - $wrapper.height()) / 2);
                    margin_top = margin_top > 30 ? margin_top : 30;
                    // adjust margin-top to actual height
                    $wrapper.animate({
                        'margin-top' : margin_top + 'px'
                    }, 300);
                });
            }
			
            // Lightbox events for Images of all sorts
            $('a[href$=".gif"], a[href$=".jpg"], a[href$=".png"], a[href$=".svg"]').not('.direct-open').on('click', handleClick);
            
            // Lightbox events for YouTube Videos, consent needed
            window.consentManager.subscribe('YouTube Video').then(function() {
                $('a[href*="youtube.com"], a[href*="youtu.be"]').not('.direct-open').on('click', handleClick);    
            });

            var hash = window.location.hash;
            var targeObject = $(hash);
            if (hash.substring(0, 11) == '#media-link' && targeObject.length > 0 ) {
                $(document).ready(() => {
                    setTimeout(() => {
                        targeObject.click();
                    }, 5000)
                })
            }
        },

        getYoutubeEmbedUrl: function(url) {
            // see http://stackoverflow.com/questions/5830387/how-to-find-all-youtube-video-ids-in-a-string-using-a-regex/5831191#5831191
            var regExp = /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube(?:-nocookie)?\.com\S*[^\w\s-])([\w-]{11})(?=[^\w-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/ig;
            // exit if regExp does not match (is not a youtube url)
            if (url.match(regExp) == null) return false;

            // return the youtube nocookie embed url
            return url.replace(regExp, '//www.youtube-nocookie.com/embed/$1?rel=0');
        }

    }

    // CALL INIT
    $(document).ready(function() {
        _private.init();
    });

    // PUBLIC FUNCTIONS
    return {}

}(jQuery));
